export default "__VITE_ASSET__d3874719__"